import React, { useEffect } from 'react';
import { NotFoundErrorPageAsync } from '@jira/platform__not-found-error-page/src/NotFoundErrorPageAsync.tsx';

import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';

const useLocation = createRouterSelector(({ location }) => location.pathname);

export const NotFound = (): React.JSX.Element => {
	const pathname = useLocation();

	useEffect(() => {
		fireErrorAnalytics({
			meta: {
				id: 'serviceHubPageNotFound',
				packageName: 'jiraServicedeskCustomerServiceServiceHubs',
				teamName: 'boysenberry',
			},
			sendToPrivacyUnsafeSplunk: true,
			attributes: {
				pathname,
			},
		});
	}, [pathname]);

	return <NotFoundErrorPageAsync />;
};
